import { render, staticRenderFns } from "./ManageChallenges.vue?vue&type=template&id=c0695894&scoped=true"
import script from "./ManageChallenges.vue?vue&type=script&lang=js"
export * from "./ManageChallenges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0695894",
  null
  
)

export default component.exports